import { render } from "./VirtualMachineKeypairs.vue?vue&type=template&id=af12a066&scoped=true"
import script from "./VirtualMachineKeypairs.vue?vue&type=script&lang=js"
export * from "./VirtualMachineKeypairs.vue?vue&type=script&lang=js"

import "./VirtualMachineKeypairs.vue?vue&type=style&index=0&id=af12a066&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af12a066"]])

export default __exports__